// Hindi translations for the DEFAULT journey content. Keyed by the exact
// English default strings so it covers both the frontend DEFAULT_JOURNEYS and
// the seeded Home campaign (identical strings) without any DB migration.
// Admin-edited custom text simply falls back to what was typed.
const HI = {
  // Bhagavatam
  "Vani — Hear the Glories": "वाणी — महिमा सुनें",
  "Senior devotees speak on the glories of Srimad Bhagavatam.":
    "वरिष्ठ भक्त श्रीमद् भागवतम् की महिमा का वर्णन करते हैं।",
  "Darshan of the Twelve Cantos": "बारह स्कंधों का दर्शन",
  "Eighteen thousand verses across twelve sacred volumes.":
    "बारह पवित्र खंडों में अठारह हज़ार श्लोक।",
  "Received Across the World": "समस्त विश्व में स्वीकृत",
  "Seekers everywhere are bringing the Bhagavatam home.":
    "हर जगह जिज्ञासु भागवतम् को अपने घर ला रहे हैं।",
  "From Our Hands to Your Altar": "हमारे हाथों से आपकी वेदी तक",
  "We handle delivery, installation, kirtan and prasadam — effortlessly.":
    "डिलीवरी, स्थापना, कीर्तन और प्रसादम — सब हम सहजता से संभालते हैं।",
  "Bring Srimad Bhagavatam Home": "श्रीमद् भागवतम् को घर लाएँ",
  "Begin a lifetime with Krishna's words. Share your name and we'll guide you personally.":
    "कृष्ण के वचनों के साथ एक नए जीवन का आरंभ करें। अपना नाम साझा करें, हम आपका व्यक्तिगत मार्गदर्शन करेंगे।",
  "I am Interested — Chat on WhatsApp": "मुझे रुचि है — WhatsApp पर बात करें",
  "Book Your Copy Directly": "अपनी प्रति सीधे बुक करें",

  // Mahaprasadam
  "The Offering": "भोग अर्पण",
  "Watch how mercy is cooked, offered and shared.":
    "देखें कैसे कृपा पकाई, अर्पित और बाँटी जाती है।",
  "The Community Feast": "सामुदायिक भोज",
  "Sanctified food that nourishes body and soul.":
    "पवित्र भोजन जो तन और मन दोनों को तृप्त करता है।",
  "Receive Mahaprasadam": "महाप्रसादम् प्राप्त करें",
  "Let His mercy reach your home and community.":
    "उनकी कृपा आपके घर और समुदाय तक पहुँचने दें।",
  "Request Mahaprasadam — Chat on WhatsApp":
    "महाप्रसादम् का अनुरोध करें — WhatsApp पर बात करें",

  // Chanting
  "Hear the Holy Name": "पवित्र नाम सुनें",
  "A gentle sample of the maha-mantra to chant along.":
    "साथ जप करने के लिए महामंत्र का एक मधुर अंश।",
  "Chant a Round": "एक माला जपें",
  "Tap the bead 108 times to complete one round.":
    "एक माला पूर्ण करने हेतु मनके को १०८ बार स्पर्श करें।",
  "Begin Your Practice": "अपनी साधना आरंभ करें",
  "Join a chanting circle and be supported on the path.":
    "एक जप मंडली से जुड़ें और मार्ग पर सहयोग पाएँ।",
  "Join Chanting Circle — Chat on WhatsApp":
    "जप मंडली से जुड़ें — WhatsApp पर बात करें",

  // Darshan
  "The Virtual Altar": "आभासी वेदी",
  "Invite His beautiful form into your home.":
    "उनके सुंदर स्वरूप को अपने घर आमंत्रित करें।",
  "Bring Home Darshan": "दर्शन घर लाएँ",
  "Receive a blessed wallpaper or framed darshan for your home.":
    "अपने घर हेतु एक मंगलमय वॉलपेपर या सुसज्जित दर्शन प्राप्त करें।",
  "Receive Darshan — Chat on WhatsApp": "दर्शन प्राप्त करें — WhatsApp पर बात करें",

  // Arrival photo-story captions
  "Your set is lovingly packed and dispatched.":
    "आपका सेट स्नेहपूर्वक पैक कर भेजा जाता है।",
  "Delivered to your doorstep with care.":
    "सावधानी से आपके द्वार तक पहुँचाया जाता है।",
  "Installed on your home altar.": "आपके घर की वेदी पर स्थापित किया जाता है।",
  "A joyful kirtan blesses your home.": "एक आनंदमय कीर्तन आपके घर को धन्य करता है।",
  "Prasadam is shared with family & friends.":
    "प्रसादम् परिवार और मित्रों के साथ बाँटा जाता है।",

  // Canto titles
  "Canto 1 · Creation": "स्कंध १ · सृष्टि",
  "Canto 2 · The Cosmic Manifestation": "स्कंध २ · ब्रह्मांडीय अभिव्यक्ति",
  "Canto 3 · The Status Quo": "स्कंध ३ · यथास्थिति",
  "Canto 4 · The Creation of the Fourth Order": "स्कंध ४ · चतुर्थ सृष्टि",
  "Canto 5 · The Creative Impetus": "स्कंध ५ · सृजन-प्रेरणा",
  "Canto 6 · Prescribed Duties for Mankind": "स्कंध ६ · मानव के विहित कर्तव्य",
  "Canto 7 · The Science of God": "स्कंध ७ · ईश्वर का विज्ञान",
  "Canto 8 · Withdrawal of the Cosmic Creations": "स्कंध ८ · ब्रह्मांडीय संहार",
  "Canto 9 · Liberation": "स्कंध ९ · मुक्ति",
  "Canto 10 · The Summum Bonum": "स्कंध १० · परम कल्याण",
  "Canto 11 · General History": "स्कंध ११ · सामान्य इतिहास",
  "Canto 12 · The Age of Deterioration": "स्कंध १२ · कलियुग",

  // Canto lines
  "Vyasa's compassion": "व्यास की करुणा",
  "Pariksit is cursed": "परीक्षित को श्राप",
  "Sukadeva arrives": "शुकदेव का आगमन",
  "The path of liberation": "मोक्ष का मार्ग",
  "The universal form": "विराट रूप",
  "Vidura's pilgrimage": "विदुर की तीर्थयात्रा",
  "Kapila's teachings": "कपिल की शिक्षाएँ",
  "Prithu Maharaj": "पृथु महाराज",
  "Lord Shiva & the Prachetas": "भगवान शिव और प्रचेता",
  Rishabhadeva: "ऋषभदेव",
  "Bharata Maharaj": "भरत महाराज",
  "Cosmic structure": "ब्रह्मांड की संरचना",
  "Ajamila delivered": "अजामिल का उद्धार",
  "The Hare Krishna maha-mantra": "हरे कृष्ण महामंत्र",
  "Prahlada Maharaj": "प्रह्लाद महाराज",
  "Lord Nrisimhadeva": "भगवान नृसिंहदेव",
  "Gajendra's prayers": "गजेंद्र की प्रार्थना",
  "Churning the ocean": "समुद्र मंथन",
  Vamanadeva: "वामनदेव",
  "The dynasties of kings": "राजाओं के वंश",
  "Lord Ramachandra": "भगवान रामचंद्र",
  "Krishna's birth": "कृष्ण-जन्म",
  "Vrindavana pastimes": "वृंदावन लीलाएँ",
  "The rasa dance": "रास नृत्य",
  "Uddhava-gita": "उद्धव-गीता",
  "The final teachings": "अंतिम शिक्षाएँ",
  "Signs of Kali-yuga": "कलियुग के लक्षण",
  "Glories of the Bhagavatam": "भागवतम् की महिमा",
};

// Translate a default journey string to Hindi when lang === "hi"; otherwise (or
// for admin-customised text with no mapping) return the original.
export const trJourney = (text, lang) =>
  lang === "hi" && text && HI[text] ? HI[text] : text;
